<template>
  <div class="home">
    <v-row justify="center">
      <v-col class="py-0">

        <!-- Header -->
        <v-row>
          <v-col class="py-0">
            <div id="regHeader" class="py-4 text-center">
              <h3>Regnummer.no</h3>
            </div>
          </v-col>
        </v-row>

        <!-- Search -->
        <v-row>
          <v-col class="py-0">
            <div id="searchField">
              <v-text-field
                solo
                hide-details
                background-color="#65C6F1"
                class="my-0 red--text"
                v-model="regNumber"
                placeholder="AB12345"
                autofocus
                flat
                @keyup.enter="getCarInfo"></v-text-field>
            </div>
          </v-col>
        </v-row>

        <!-- Button -->
        <v-row>
          <v-col class="py-0">
            <div id="searchButton">
              <v-btn :loading="loading" class="py-4" text @click="getCarInfo"><h3>Søk</h3></v-btn>
            </div>
          </v-col>
        </v-row>

        <!-- Regnr Header -->
        <v-row v-if="carInfo">
          <v-col class="pt-5">
            <h2 class="categoryHeader text-center white--text font-weight-light">{{ carInfo.regNumber }}</h2>
          </v-col>
        </v-row>

        <!-- Car info -->
        <v-row v-if="carInfo">
          <v-col>
            <div v-for="(category, index) in categories" :key="category.category">
              <h2 class="categoryHeader text-center white--text font-weight-light" :class="{ 'pt-5': index !== 0 }">{{ category.category }}</h2>

              <v-row v-for="item in category.items" :key="item.value">
                <v-col class="py-0 pr-3 text-right grey--text text--darken-3">{{ item.label }}</v-col>
                <v-col class="py-0 pl-3 text-left white--text">{{ itemValue(item.value) }}</v-col>
              </v-row>
            </div>
          </v-col>
        </v-row>

        <!-- Kilometerstand -->
        <v-row v-if="carInfo">
          <v-col>
            <h2 class="categoryHeader text-center white--text font-weight-light">Kilometerstand</h2>

            <v-row v-for="(entry, index) in carInfo.data.kmstandHistorikk.kilometerstandInfo" :key="index">
              <v-col class="py-0 pr-3 text-right grey--text text--darken-3">{{ formatKmStandDate(entry.dato) }}</v-col>
              <v-col class="py-0 pl-3 text-left white--text">{{ entry.kmstand }}</v-col>
            </v-row>
          </v-col>
        </v-row>

        <!-- Liens -->
        <v-row v-if="carInfo">
          <v-col class="mt-5 text-center grey--text text--darken-2">
            <p v-if="carLiens">Heftelser: {{ formatMoney(carLiens) }}</p>
            <p v-else>Ingen tinglyste heftelser</p>
          </v-col>
        </v-row>

        <!-- Owner -->
        <v-row v-if="carInfo">
          <v-col class="text-center white--text">
            <p>Hvem eier bilen?</p>
            <p>Send "<b>REGNR {{ regNumber.toUpperCase() }}</b>" til 2282</p>
            <p>Tjenesten koster kr. 3,- pr. mottatt melding og er <a class="grey--text text--darken-2" href="#">Statens Vegvesen</a> sin egen tjeneste</p>
          </v-col>
        </v-row>

      </v-col>
    </v-row>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'Home',

  data: () => ({
    regNumber: null,
    carInfo: null,
    carLiens: null,
    loading: null,
    errMessage: null,
    categories: [
      { category: 'Generelt',
        items: [
          { value: 'numSearches', label: 'Antall ganger søkt på' },
          { value: 'data.merke', label: 'Merke' },
          { value: 'data.modell', label: 'Modell' },
          { value: 'data.brukstype.gruppe', label: 'Kjøretøygruppe' },
          { value: 'data.registreringsaar', label: 'Registreringsår' },
          { value: 'data.seter', label: 'Antall seter' },
          { value: 'data.farge', label: 'Farge' },
          { value: 'data.drivstofftype', label: 'Drivstoff' },
          { value: 'data.understellsnr', label: 'Understellsnummer' },
          { value: 'data.forstegangsreg', label: 'Reg. første gang i Norge' },
          { value: 'data.registrertEierDato', label: 'Registrert på eier' },
          { value: 'data.registrertDistrikt', label: 'Registrert i distrikt' },
          { value: 'data.eukontrollSist', label: 'Sist EU kontroll' },
          { value: 'data.eukontrollfrist', label: 'Neste EU kontroll' }
        ]
      },
      { category: 'Mål og vekt',
        items: [
          { value: 'data.lengde', label: 'Lengde' },
          { value: 'data.bredde', label: 'Bredde' },
          { value: 'data.egenvekt', label: 'Egenvekt' },
          { value: 'data.egenvektMedForer', label: 'Egenvekt med fører' },
          { value: 'data.totalvekt', label: 'Tillat totalvekt' },
          { value: 'data.nyttelast', label: 'Maks nyttelast' },
          { value: 'data.tilhengervektMBrems', label: 'Maksvekt tilhenger m/brems' },
          { value: 'data.tilhengervektUBrems', label: 'Maksvekt tilhenger u/brems' },
          { value: 'data.tilhengervektKopl', label: 'Maksvekt på tilhengerkobling' },
          { value: 'data.vogntogvekt', label: 'Maks vogntogvekt' },
          { value: 'data.taklast', label: 'Maks taklast' },
          { value: 'data.akseltrykkForan', label: 'Maks aksellast foran' },
          { value: 'data.akseltrykkBak', label: 'Maks aksellast bak' }
        ]
      },
      {
        category: 'Motor/Kraftoverføring',
        items: [
          { value: 'data.slagvolum.oppgitt', label: 'Slagvolum' },
          { value: 'data.motorytelse.oppgitt', label: 'Motorytelse/effekt' },
          { value: 'data.antallAksler', label: 'Antall aksler' },
          { value: 'data.akslerMedDrift', label: 'Antall aksler med drift' }
        ]
      },
      {
        category: 'Dekk/Felg',
        items: [
          { value: 'data.dekkdimensjonForan', label: 'Dekk foran' },
          { value: 'data.dekkdimensjonBak', label: 'Dekk bak' },
          { value: 'data.hastighetsindeksForan', label: 'Hastighetsindeks foran' },
          { value: 'data.hastighetsindeksBak', label: 'Hastighetsindeks bak' },
          { value: 'data.lastindeksForan', label: 'Lastindeks foran' },
          { value: 'data.lastindeksBak', label: 'Lastindeks bak' },
          { value: 'data.innpressForan', label: 'Innpress foran' },
          { value: 'data.innpressBak', label: 'Innpress bak' }
        ]
      }
    ]
  }),

  methods: {
    getCarInfo () {
      console.log('getCarInfo triggered')
      this.loading = true
      this.carInfo = null
      axios
        .get('https://regnummer.no/api/' + this.regNumber + '/carinfo')
        .then(result => {
          console.log('Success:', result.data)
          this.carInfo = result.data

          axios
            .get('https://regnummer.no/api/' + this.regNumber + '/liens')
            .then(result => {
              console.log('Success:', result.data)
              this.carLiens = result.data.amount
              this.errMessage = null
              this.loading = false
            })
            .catch(err => {
              console.error('Error:', err)
              this.errMessage = err
              this.loading = false
            })
        })
        .catch(err => {
          console.error('Error:', err)
          this.errMessage = err
          this.loading = false
        })
    },

    itemValue (itemValue) {
      switch (itemValue) {
        case 'data.slagvolum.oppgitt':
          return `${this.carInfo.data.slagvolum.oppgitt} (${this.carInfo.data.slagvolum.oppgitt / 1000} liter)`

        case 'data.motorytelse.oppgitt':
          return `${this.carInfo.data.motorytelse.oppgitt}${this.carInfo.data.motorytelse.oppgittBenevning} (${this.carInfo.data.motorytelse.hestekrefter}hk)`
        default:
          return itemValue.split('.').reduce((o, i) => o[i], this.carInfo)
      }
    },

    formatMoney (amount, decimalCount = 2, decimal = ',', thousands = ' ') {
      try {
        decimalCount = Math.abs(decimalCount)
        decimalCount = isNaN(decimalCount) ? 2 : decimalCount

        const negativeSign = amount < 0 ? '-' : ''

        let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString()
        let j = (i.length > 3) ? i.length % 3 : 0

        return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : '')
      } catch (e) {
        console.log(e)
      }
    },

    formatKmStandDate (incomingDate) {
      const newDateObj = new Date(incomingDate)
      let newDate = newDateObj.getDate()
      let newMonth = newDateObj.getMonth() + 1
      let newYear = newDateObj.getFullYear()

      if (newDate < 10) newDate = '0' + newDate
      if (newMonth < 10) newMonth = '0' + newMonth

      return newDate + '.' + newMonth + '.' + newYear
    }
  }
}
</script>

<style>
  a, a:visited {
    text-decoration: none;
  }

  #regHeader {
    background-color: #fff;
    text-transform: uppercase;
    color: #65C6F1;
  }

  #searchField .v-input {
    border-radius: 0;
    background-color: #65C6F1;
  }

  #searchField input {
    text-align: center;
    color: #fff;
    text-transform: uppercase;
  }

  #searchButton {
    background-color: #6AC4D4;
  }

  #searchButton .v-btn {
    color: #fff;
    width: 100%;
    height: 100%;
  }

  .categoryHeader {
    text-transform: uppercase;
  }
</style>
